import { Pipe, PipeTransform } from '@angular/core';
import { MenuNode } from '../classes/';
@Pipe({
  name: 'enabledNodes'
})
export class EnabledNodesPipe implements PipeTransform {

  	transform(nodes: Array<MenuNode>, args?: any): Array<MenuNode> {
   		let filtered_nodes = new Array<MenuNode>();
   		for(let node of nodes){
   			if(node.isEnabled()){
   				filtered_nodes.push(node);
   			}
   		}
   		return filtered_nodes;
	}

}
